import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from '@mui/material'
import { useFormikContext } from 'formik'
import { useEffect } from 'react'

import { isSomeEnum } from 'src/common/utils'
import { HelperWrapper } from 'src/components/helper-wrapper'
import { ECreateScanMode, EScanRecordType, ETranslationNs, IScanCreateForm } from 'src/types'
import { useScanRelationContext } from '../../form-wrapper/relations-context.component'

import { useStyles } from '../styles'

export const SectionRadioButtons = () => {
  const { formType, setFormType, createScanMode } = useScanRelationContext()
  const { setValues, validateForm } = useFormikContext<IScanCreateForm>()
  const classes = useStyles()

  useEffect(() => {
    validateForm()
  }, [formType, validateForm])

  const handleChange = (e: any, val: string) => {
    const isFormType = isSomeEnum(EScanRecordType)
    if (!isFormType(val)) return

    setValues(
      (prev) => ({
        ...prev,
        impact_id: null,
        impact_quantity: null,
        sender_reference_id: null,
        receiver_reference_id: null,
        invoice_reference: null,
      }),
      false,
    )
    setFormType(val)
  }

  return (
    <FormControl
      disabled={createScanMode !== ECreateScanMode.Default}
      className={classes.radioButtons}
    >
      <FormLabel className={classes.radioLabel} focused={false}>
        <HelperWrapper t="scan-form-record-type" ns={ETranslationNs.ScanForm} />
      </FormLabel>
      <RadioGroup row value={formType} onChange={handleChange}>
        <FormControlLabel
          value={EScanRecordType.General}
          control={<Radio />}
          label={<HelperWrapper t="scan-general-title" ns={ETranslationNs.ScanForm} />}
        />
        <FormControlLabel
          value={EScanRecordType.Movement}
          control={<Radio />}
          label={<HelperWrapper t="scan-form-movement-checkbox" ns={ETranslationNs.ScanForm} />}
        />
        <FormControlLabel
          value={EScanRecordType.Impact}
          control={<Radio />}
          label={<HelperWrapper t="scan-form-impact-checkbox" ns={ETranslationNs.ScanForm} />}
        />
      </RadioGroup>
    </FormControl>
  )
}
